import Repository from "./Repository";

export default {
    getToken(){
        return Repository.new().get("/sources/connect-gdrive");
    },
    getBoxToken(){
        return Repository.new().get("/sources/connect-box");
    },
    getDropBoxtoken(){
        return Repository.new().get("/sources/connect-dropbox")
    },
    removeToken(email){
        return Repository.new().post("/sources/disconnect-gdrive", {email: email});
    },
    getFiles(token){
        return Repository.new().post("/sources/gdrive-files", {token: token});
    },
    getConnectedAccounts(){
        return Repository.new().get("/sources/get-gdrive-connected");
    },
}